import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteNominationWebsite: (
  fetchContext: FetchContext,
  websiteId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, websiteId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nomination-websites/${websiteId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete nomination website'));
